import { useAuth } from "./useAuth";
import { AuthResponse } from "../api/auth/auth.responses";
import { BASE_URL } from "../api/internal";
import axios from "axios";

// Module-level deduplication: if a refresh is already in flight,
// subsequent callers share the same promise instead of firing new requests.
let refreshPromise: Promise<string> | null = null;

function useRefreshToken() {
  const { setAccessToken } = useAuth();

  const refresh = async () => {
    if (refreshPromise) {
      return refreshPromise;
    }

    refreshPromise = axios
      .get<AuthResponse>(`${BASE_URL}/auth/refresh`, {
        withCredentials: true,
      })
      .then((response) => {
        setAccessToken(response.data.accessToken);
        return response.data.accessToken;
      })
      .finally(() => {
        refreshPromise = null;
      });

    return refreshPromise;
  };

  return refresh;
}

export default useRefreshToken;
